import { MeshPhysicalMaterial } from "three";

export const BubbleMaterial = async () => {
	return new MeshPhysicalMaterial({
		opacity: 0.7,
		roughness: 0.3,
		transmission: 0,
		thickness: 0.05,
		transparent: true,
		// clearcoat: 1,
		// roughness: 0.1,
		// transmission: 1,
		// thickness: 0.4,
		// opacity: 1,
	});
};
